import { ROUTE_FORGOT_PASSWORD_CONFIRM } from "consts";

/**
 * Maps an auth pathname to the FormContainer `version` key.
 * Single-segment routes use `/auth/:version` (e.g. login, resetpwd).
 * Multi-segment LLD paths are mapped explicitly (forgot password confirm).
 * Option A forward-compat: `/auth/forgotpwd` resolves via the single-segment rule.
 */
export default function resolveAuthVersion(pathname) {
  const normalized = (pathname || "").replace(/\/+$/, "");

  if (normalized === ROUTE_FORGOT_PASSWORD_CONFIRM) {
    return "forgotpwd";
  }

  const segments = normalized.split("/").filter(Boolean);
  const authIndex = segments.indexOf("auth");

  if (authIndex >= 0 && segments.length === authIndex + 2) {
    return segments[authIndex + 1];
  }

  return "login";
}
